import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import RouteApi from "../Backend/Backend";
import StudPaystack from "../Components/StudPaystack";

export default function PaymentPage() {
  const { payid } = useParams();
  const { fetchPaymentByToken } = RouteApi();

  const [payment, setPayment] = useState(null);
  const [loading, setLoading] = useState(true);

  const schoolname = localStorage.getItem("schoolname");

  const loadPayment = async () => {
    setLoading(true);
    const data = await fetchPaymentByToken(payid);
    if (data) setPayment(data);
    else toast.error("Payment not found or invalid link");
    setLoading(false);
  };

  useEffect(() => {
    loadPayment();
  }, [payid]);

  if (loading)
    return (
      <div className="text-center py-lg-12 py-14">
        <div className="text-center">
        <div className="lds-facebook">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        </div>
        </div>

        <p className="fs-3 text-purple2 fw-medium">Loading payment...</p>
      </div>
    );

  if (!payment)
    return (
      <div className="text-center py-5">
        <h5>Payment record not found</h5>
      </div>
    );

  return (
    <div
      className="container px-lg-15 px-4 py-lg-12 py-10"
    >

      <div className="col-lg-10 offset-lg-1">
      <div className="card bg-white shadow-none px-lg-6 py-lg-4 px-6 py-4" 
      style={{ borderRadius: '30px' }}>

      <div className="py-lg-3 px-lg-3 px-2 py-2">

      <div className="fs-t2 fw-medium text-purple3 text-center mb-4">
        {schoolname} Pay Service
      </div>

      <div className="fs-4 text-purple2 mb-3"><span className="fw-medium">Student:</span> {payment.stud_name}</div>
      <div className="fs-4 text-purple2 mb-3"><span className="fw-medium">Class:</span> {payment.stud_class}</div>
      <div className="fs-4 text-purple2 mb-3">
      <span className="fw-medium">Payment Type:</span>{" "}
        {payment.payment_type.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())}
      </div>
      <div className="fs-4 text-purple2 mb-3 fw-semibold"><span className="fw-medium">Amount:</span> ₦{Number(payment.amount).toLocaleString()}</div>
      <div className="fs-4 text-purple2 mb-3">
      <span className="fw-medium">Status:</span>{" "}
        <span
          className={`badge ${
            payment.status === "verified"
              ? "bg-success"
              : payment.status === "failed"
              ? "bg-danger"
              : "bg-warning text-dark"
          }`}
        >
          {payment.status}
        </span>
      </div>

      <div className="text-center">
      {payment.status !== "verified" && (
          <StudPaystack
            email={payment.email}
            amount={payment.amount}
            name={payment.stud_name}
            reference={payment.reference}
            onVerified={loadPayment} // reload after verification
          />
        )}
      </div>
      </div>
      </div>
      </div>

    </div>
  );
}
